import {
  getEntityDataViewState,
  getPersonalPanelLoadingStates,
  getPersonalPanelState,
  getStory,
  mapPersonalPanelDownloads,
  mapPersonalPanelNotifications,
} from './getters'
import {
  selectActiveFilters,
  selectActiveFiltersCount,
  selectApproval,
  selectAssignment,
  selectAssignmentsByStage,
  selectCompletedTasks,
  selectCompletedApprovals,
  selectContent,
  selectContentCount,
  selectContextByEntityId,
  selectCurrentBrand,
  selectCurrentBrandId,
  selectCurrentStoryId,
  selectCurrentStory,
  selectCurrentUserAvatarUuid,
  selectCurrentWeekChannels,
  selectCurrentWeekLabelSets,
  selectFilteredContent,
  selectFilteredMoments,
  selectLabels,
  selectLabelSets,
  selectMe,
  selectModifiedMoments,
  selectMomentContentIds,
  selectMomentById,
  selectMomentIndices,
  selectMoments,
  selectMomentPreviewData,
  selectNormalizedAssignments,
  selectNormalizedPhaseItems,
  selectOverdueTasks,
  selectOverdueApprovals,
  selectPendingApprovals,
  selectPreConstraint,
  selectPrimaryLabelSet,
  selectPrimaryLabelSetId,
  selectProxiedMoments,
  selectResponse,
  selectResponsesByAssignment,
  selectStage,
  selectStagesByWorkflowId,
  selectStories,
  selectStoriesMeta,
  selectStory,
  selectStoryIndex,
  selectTodoTasks,
  selectUpcomingTasks,
  selectUser,
  selectUserIds,
  selectUserWithAvatar,
  selectUsers,
  selectUsersToArray,
  selectUsersWithoutViewers,
  selectV1LabelSets,
  selectWeekViewStartDay,
  selectWeekViewWidth,
  selectWorkflowByContext,
  selectSelectedFilters,
} from './selectors'
import {
  deDupe,
  getRelevantImageProperties,
  parseMomentData,
} from './selectors/views/helpers'

export const getters = {
  getEntityDataViewState,
  getPersonalPanelLoadingStates,
  getPersonalPanelState,
  getStory,
  mapPersonalPanelDownloads,
  mapPersonalPanelNotifications,
}

export const selectorHelpers = {
  deDupe,
  getRelevantImageProperties,
  parseMomentData,
}

export const selectors = {
  getStory,
  selectActiveFilters,
  selectSelectedFilters,
  selectActiveFiltersCount,
  selectApproval,
  selectAssignment,
  selectAssignmentsByStage,
  selectCompletedTasks,
  selectCompletedApprovals,
  selectContent,
  selectContentCount,
  selectContextByEntityId,
  selectCurrentBrand,
  selectCurrentBrandId,
  selectCurrentStoryId,
  selectCurrentStory,
  selectCurrentUserAvatarUuid,
  selectCurrentWeekChannels,
  selectCurrentWeekLabelSets,
  selectFilteredContent,
  selectFilteredMoments,
  selectLabels,
  selectLabelSets,
  selectMe,
  selectModifiedMoments,
  selectMomentContentIds,
  selectMomentById,
  selectMomentIndices,
  selectMoments,
  selectMomentPreviewData,
  selectNormalizedAssignments,
  selectNormalizedPhaseItems,
  selectOverdueTasks,
  selectOverdueApprovals,
  selectPendingApprovals,
  selectPreConstraint,
  selectPrimaryLabelSet,
  selectPrimaryLabelSetId,
  selectProxiedMoments,
  selectResponse,
  selectResponsesByAssignment,
  selectStage,
  selectStagesByWorkflowId,
  selectStories,
  selectStoriesMeta,
  selectStory,
  selectStoryIndex,
  selectTodoTasks,
  selectUpcomingTasks,
  selectUser,
  selectUserIds,
  selectUserWithAvatar,
  selectUsers,
  selectUsersToArray,
  selectUsersWithoutViewers,
  selectV1LabelSets,
  selectWeekViewStartDay,
  selectWeekViewWidth,
  selectWorkflowByContext,
}
